import type { RefundReason } from "@ticketnjoy/types";

import { useT } from "@/lib/i18n";

const PAYMENT_PROVIDERS = new Set([
  "stub",
  "dev",
  "param",
  "halkbank",
  "isbank",
  "tami",
  "garanti",
  "wallet",
  "free",
  "unknown",
]);

export const REFUND_REASONS: readonly RefundReason[] = [
  "CustomerRequest",
  "EventCancelled",
  "OrderError",
  "Other",
];

const REFUND_REASON_SET = new Set<string>(REFUND_REASONS);

/** Backend'in Türkçe ürettiği etiket yerine ham sağlayıcı anahtarından çeviri; bilinmeyen anahtar olduğu gibi gösterilir. */
export function usePaymentProviderLabel() {
  const t = useT("paymentProvider");
  return (provider: string | null | undefined) => {
    const key = (provider || "unknown").toLowerCase();
    return PAYMENT_PROVIDERS.has(key) ? t(key) : (provider ?? "");
  };
}

export function useRefundReasonLabel() {
  const t = useT("refundReason");
  return (reason: string) => (REFUND_REASON_SET.has(reason) ? t(reason) : reason);
}
